import styled from 'styled-components';

export const DiscountOverlayWrapper = styled.div`
`;

export const DiscountHeader = styled.div`
    background-color: #e8f3ff;
    padding: 0.8rem 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .cabName {
        font-size: 1.6rem;
        font-weight: 600;
    }
    .amount {
        font-size: 1.4rem;
        font-weight: 600;
        margin-left: 0.8rem;
    }
`;

export const OffersListItem = styled.div`
    padding : 1.1rem 1.5rem;
    background-color : #fff;
    border-top : solid 1px rgba(151, 151, 151,0.1);
`;

export const ItemRow = styled.div`
    display : flex;
    justify-content : space-between;
    align-items : center;
    margin-top : ${props => props.marginTop ? props.marginTop : 0};
`;

export const Icon = styled.div`
    display : flex;
    justify-content : center;
    align-items : center;
    margin: ${props => props.margin ? props.margin : '-10px -4px 0'};
`;

export const DiscountTagCont = styled.div`
    padding : 0.4rem 0.8rem;
    background-color : ${props => props.bgColor ? props.bgColor : '#fff' };
    display : flex;
    align-items : center;
    border-radius : 1rem;
`;

export const DiscountIcon = styled.img`
    width : ${props => props.width ? props.width : ''};
    height : ${props => props.height ? props.height : ''};
`;

export const DiscountTxt = styled.span`
    font-family: 'Rubik';
    font-size: 1.2rem;
    font-weight: 600;
    margin-left : 0.3rem;
    color: ${props => props.color ? props.color : '#141823'};
`;

export const PreAppliedTxt = styled.span`
    display : inline-block;
    padding : 0.4rem 0.6rem;
    background-color : #e9f6ea;
    font-size: 1rem;
    color: #2bac36;
`;

export const DiscountDesc = styled.span`
    font-size: 1.4rem;
    color: #141823;
`;

export const DiscountPrice = styled.span`
    font-size: 1.2rem;
    font-weight: 600;
    color: #141823;
`;